// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 1 hooks for backend/search.

import { useBackend } from '../useBackend'

/** POST /api/search/getGlobalSearch */
export function useGetGlobalSearch<T = any>() {
  return useBackend<T>('search/getGlobalSearch')
}
